<template>
    <header class="header">
        <div class="header--wrap">
          <h1 class="site--title"><router-link :to="{ name: 'Home' }">Paracelsia Le Saigné</router-link></h1>
          <TheNavigation />
        </div>

        <!--<div class="menu" ref="menu" v-bind:class="[isVisible ? 'opened' : '']">

            <div class="menu--wrap">
                <div class="menu--title">IL SERAIT DÉJÀ AGRÉ- ABLE DE PROVOQUER UNE ÉMOTION.</div>

                <div class="bottom">
                    <ul class="menu--list-nav">
                        <li><a href="#">Parutions</a></li>
                        <li><a href="#">Nouvelles</a></li>
                        <li><a href="#">Correspondances</a></li>
                        <li><a href="#">Paroles</a></li>
                    </ul>
                    <ul class="menu--list-links">
                        <li><a href="#">Amazon</a></li>
                        <li><a href="#">Twitter</a></li>
                        <li><a href="#">Instagram</a></li>
                        <li><a href="#">Email</a></li>
                    </ul>
                </div>
            </div>
            
        </div>-->
        <!--<TheMenu />-->
    </header>
</template>

<script>
import TheNavigation from "@/components/TheNavigation"
//import TheMenu from "@/components/TheMenu"
export default {
  components: {
    TheNavigation,
    //TheMenu
  },
  data() {
    return{
      isVisible: false,
    }
  },
  methods: {
    /*showMenu(isVisible){
      isVisible = !isVisible;
      
      return isVisible;
    }*/
  }
}
</script>
<style lang="scss" scoped>
.header{
  position: relative;
  width: 100%;

  padding: 10px 0;
  text-align: center;
  z-index: 100;

  &--wrap{
    position: relative;
    z-index: 101;
  }
}
.site--title{
  position: absolute;
  top: 0;
  left : 50%;
  color: $brown;
  font-family: $NewEddy;
  @include font(30,40);
  transform: translate(-50%, 0);
  text-transform: uppercase;
}
.menu{
    position: fixed;
    color: $black;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    z-index: 100;


    opacity: 0;
    visibility: hidden;

    &.opened{
        opacity: 1;
        visibility: visible;
    }

    &--wrap{
        @include wrap($wrapperXL);
    }

    &--title{
        @include font()
    }

    &--list{

        &-nav{
            text-align: left;
        }

        &-links{
            text-align: right;
        }
    }
}

.bottom{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
</style>